import { observer } from 'mobx-react-lite';
import React from 'react';
import { TypographyProps } from '@mui/material';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export type CopyrightProps = TypographyProps;

const Copyright: React.FC<CopyrightProps> = observer(function CopyrightComponent({
    variant = 'body2',
    color = 'textSecondary',
    align = 'center',
    ...props
}) {
    return (
        <Typography variant={variant} color={color} align={align} {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://www.travviagroup.com/" sx={{ color: 'inherit' }}>
                Travvia
            </Link>
        </Typography>
    );
});

export default Copyright;
